import { useEffect, useState } from 'react'
import { SnackbarContent, IconButton, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Snackbar from '@mui/material/Snackbar'
import { bulletinBoardHeadermessage } from '@fireflyhealth/api'
import { fireAndForget } from '~/shared/lib/fireAndForget'
import { required } from '~/shared/lib/required'

const snackBarBackgroundColors = ['#5B0FD5', '#00B580', '#F5C805', '#F5751F']

interface BannerMessageProps {
  // Only identity matters: the banner refetches when the signed-in user changes, and reads no
  // field of it.
  me: { id: number | null }
}
interface HeaderMessage {
  text: string
}
export const BannerMessage = (props: BannerMessageProps) => {
  const { me } = props
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false)
  const [bannerMessageData, setBannerMessageData] = useState<HeaderMessage | undefined>(undefined)
  const [snackBarBackgroundColor, setSnackbarBackgroundColor] = useState('')
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    setSnackbarIsOpen(false)
  }

  const action = (
    <IconButton
      sx={{ display: 'inline-block' }}
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  )

  const getHeaderMessage = async () => {
    const { data } = await bulletinBoardHeadermessage.retrieve({ id: 'random' })
    if (data) {
      setBannerMessageData(data)
      setSnackbarIsOpen(true)
      setSnackbarBackgroundColor(
        required(
          snackBarBackgroundColors[Math.floor(Math.random() * snackBarBackgroundColors.length)],
          'a banner colour',
        ),
      )
    }
  }

  useEffect(() => {
    fireAndForget('[Banner] load header message', getHeaderMessage)
  }, [me])

  if (bannerMessageData) {
    return (
      <Snackbar
        sx={{ minWidth: '65%' }}
        open={snackbarIsOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <SnackbarContent
          sx={{
            textAlign: 'center',
            width: '100%',
            fontSize: 16,
            display: 'inline-block',
            backgroundColor: snackBarBackgroundColor,
          }}
          message={
            <Box>
              {bannerMessageData?.text}
              {<Box sx={{ float: 'right' }}>{action}</Box>}
            </Box>
          }
        ></SnackbarContent>
      </Snackbar>
    )
  }
  return null
}
